export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13567.a82e57ff.jpg";